import { cloneElement } from 'react';
import useId from '../utilities/useId';
import { jsx as _jsx } from "react/jsx-runtime";
export const TableRow = _ref => {
  let {
    children,
    _isTableHeadChild,
    ...tableRowProps
  } = _ref;
  const childKeyPrefix = useId('table-row-child--');
  const renderChildren = () => {
    const normalizedChildren = Array.isArray(children) ? children : [children];
    return normalizedChildren.map((child, index) => {
      const key = child?.key ?? `${childKeyPrefix}--${index}`;
      // Extend props before rendering.
      if (child && child.props) {
        return /*#__PURE__*/cloneElement(child, {
          key,
          _isTableHeadChild: _isTableHeadChild
        });
      }
      return child;
    });
  };
  return /*#__PURE__*/_jsx("tr", {
    role: "row",
    ...tableRowProps,
    children: _isTableHeadChild ? renderChildren() : children
  });
};
export default TableRow;